import { render, staticRenderFns } from "./WebPartHRDesigner.vue?vue&type=template&id=e7248a96&scoped=true&"
import script from "./WebPartHRDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartHRDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7248a96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7248a96')) {
      api.createRecord('e7248a96', component.options)
    } else {
      api.reload('e7248a96', component.options)
    }
    module.hot.accept("./WebPartHRDesigner.vue?vue&type=template&id=e7248a96&scoped=true&", function () {
      api.rerender('e7248a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartHRDesigner.vue"
export default component.exports